import type { AssetFileDoc, AssetFolderDoc } from '@bb/domain/dist/schemas';
import { Color } from '@bb/elements-web';
import { Icon, ListItem, ListItemMeta } from 'components';
import React from 'react';
import styled from 'styled-components';
import { mimeTypeToIcon } from 'utils';

type AssetListItemProps = {
  item: AssetFolderDoc | AssetFileDoc;
  actionsEnabled: boolean;
  onAssetClick: (
    asset: AssetFolderDoc | AssetFileDoc,
    filetype: string,
  ) => void;
  onActionClick: (asset: AssetFolderDoc | AssetFileDoc) => void;
};

const AssetListItem: React.FC<AssetListItemProps> = ({
  item,
  actionsEnabled,
  onAssetClick,
  onActionClick,
}) => {
  const filetype = (item as AssetFileDoc).filetype || 'folder';

  const handleClick = () => {
    onAssetClick(item, filetype);
  };

  const handleActionClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onActionClick(item);
  };

  return (
    <StyledListItem
      data-cy={`asset-item-${item.id}`}
      onClick={handleClick}
      actions={
        actionsEnabled && [
          <StyledActionContainer
            key={`${item.id}-action-icon`}
            data-cy="asset-action-button"
            onClick={handleActionClick}
          >
            <Icon
              type={
                filetype === 'folder'
                  ? 'antdSettingOutlined'
                  : 'antdDeleteFilled'
              }
              width={16}
            />
          </StyledActionContainer>,
        ]
      }
    >
      <ListItemMeta
        avatar={<Icon type={mimeTypeToIcon(filetype)} width={14} />}
        description={item.name}
      />
    </StyledListItem>
  );
};

export default React.memo(AssetListItem);

const StyledListItem = styled(ListItem)`
  cursor: pointer;

  && {
    padding: 10px 14px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.BEERUS};
  }
`;

const StyledActionContainer = styled.span`
  padding: 4px 8px;
  cursor: pointer;
`;
